/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { ZerogTrxMoreDetailInfo } from './ZerogTrxMoreDetailInfo';

export type ZerogTrxDetailInfo = {
    TRXA: string;
    TRXTP: ZerogTrxDetailInfo.TRXTP;
    CBB: string;
    STAT: ZerogTrxDetailInfo.STAT;
    BNO: string;
    AG: string;
    FROMADDRSINFO: EvmAddressSummaryInfo;
    TOADDRSINFO: EvmAddressSummaryInfo;
    AMT: string;
    VAL: string;
    TRXF: string;
    TRXFVAL: string;
    GP: string;
    GPG: string;
    GPVAL: string;
    GL: string;
    GU: string;
    GUP: string;
    UT: number;
    TRXID: string;
    SNO: string;
    MTHID: string;
    MTHNM: string;
    MD: ZerogTrxMoreDetailInfo;
};

export namespace ZerogTrxDetailInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

